import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { GqlError, ReEditWorksheetDocument } from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

import { Worksheet } from '../../types'

const reEditWorksheet = async ({
  worksheetUid,
  reason,
}: {
  worksheetUid: Worksheet['uid']
  reason?: string
}): Promise<void> => {
  try {
    await graphqlRequest(ReEditWorksheetDocument, {
      input: {
        worksheetUid,
        reason: reason ?? '',
      },
    })
  } catch (error) {
    throw error
  }
}

export const useReEditWorksheet = (
  option?: UseMutationOption<void, GqlError>,
) => {
  return useMutation(
    ({
      worksheetUid,
      reason,
    }: {
      worksheetUid: Worksheet['uid']
      reason?: string
    }) => reEditWorksheet({ worksheetUid, reason }),
    option,
  )
}
